export type MaintenanceType =
  | 'preventive'
  | 'repair'
  | 'inspection'
  | 'cleaning';

export type MaintenanceStatus =
  | 'scheduled'
  | 'in_progress'
  | 'completed'
  | 'cancelled';

/** Estados operativos del ítem (alineado con inventario + inspección). */
export type InventoryOperationalStatus =
  | 'available'
  | 'reserved'
  | 'maintenance'
  | 'repair'
  | 'inspection'
  | 'inactive'
  | 'in_use'
  | 'sold';

export type MaintenanceTask = {
  id: string;
  companyId: string;
  inventoryItemId: string;
  type: MaintenanceType;
  status: MaintenanceStatus;
  title: string;
  description: string;
  scheduledStart: string;
  scheduledEnd: string;
  completedAt: string | null;
  assignedTo: string;
  notes: string;
  /** Placeholder — intervalo preventivo (días); sin scheduler automático. */
  preventiveIntervalDays: number | null;
  /** Placeholder — próxima inspección sugerida (YYYY-MM-DD). */
  nextInspectionDate: string | null;
  createdBy: string;
  createdAt: Date;
  updatedAt: Date;
};

export type MaintenanceTaskInput = {
  inventoryItemId: string;
  type: MaintenanceType;
  status: MaintenanceStatus;
  title: string;
  description: string;
  scheduledStart: string;
  scheduledEnd: string;
  assignedTo: string;
  notes: string;
  preventiveIntervalDays?: number | null;
  nextInspectionDate?: string | null;
};

export type MaintenanceFilters = {
  status?: MaintenanceStatus | 'all';
  type?: MaintenanceType | 'all';
  inventoryItemId?: string;
  fromDate?: string;
  toDate?: string;
  search?: string;
};

export const MAINTENANCE_TYPE_LABELS: Record<MaintenanceType, string> = {
  preventive: 'Preventivo',
  repair: 'Reparación',
  inspection: 'Inspección',
  cleaning: 'Limpieza',
};

export const MAINTENANCE_STATUS_LABELS: Record<MaintenanceStatus, string> = {
  scheduled: 'Programado',
  in_progress: 'En curso',
  completed: 'Completado',
  cancelled: 'Cancelado',
};
